<template>
    <form-row title='Contract "Binding" Acceptance Date'>
        <input-date
            v-model="date"
            name="contract_acceptance_date"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
export default {
    props: {
        value: {},
        read_only: { default: false },
    },

    computed: {
        date: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
}
</script>
